jQuery(document).ready(function ($) { 
  $('[data-product_slider]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:false,
    arrows: false,draggable:false,
    fade: true,
    asNavFor: '.slider-thumb'
  });
  $('.slider-thumb').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '[data-product_slider]',
    dots: false,arrows: false,
    centerMode: false,
    focusOnSelect: true
  });
   $(document.body).on('change','.swatch-attribute-options-wrapper input', function(){
    var t = $(this), v = t.val();
    t.parent().parent().parent().parent().find('.swatch-attribute-selected-option').text(v);
     
  });
  $(".sticky_on_mobile h3").on("click", function () {
      $(this).toggleClass("active"), $("body").toggleClass("toggleopen"), $(this).next().slideToggle(), $("#mob_note").hide();
  });
  $(".key_indicates ul li").on("click", function () {
      var a = $(this),
          b = a.data("tab");
      a.addClass("active").siblings().removeClass("active"), $("html, body").animate({ scrollTop: $(b).offset().top }, 1e3);
  });
  $(document.body).on('click', '.quantity button.plus,.quantity button.minus', function(){
    var v = $('.quantity input').val(); 
    $('#subscribe_qty').val(v);
  });
  
  if( $('#lwsubsc').is(':checked') == true ){
    var subplan = $('[data-bsub-selling-plan-input]:checked + div').text();
    $('.sub_offter .opts button span').text(subplan);
    $('.sub_offter').addClass('active');$('#activate-subscribe span').text('SUBSCRIBE & SAVE');
  }
  jQuery(document).scroll(function () {
      var d = jQuery(window).scrollTop(),
      c = jQuery(".scrolltop.current"),
      b = c.data("id"),
      a = jQuery(".key_indicates li[data-tab='" + b + "']");

    a.addClass("active").siblings().removeClass('active');
      // (b = a) && (jQuery(".key_indicates li").removeClass("active"), jQuery(a).addClass("active")),
    jQuery(".scrolltop").each(function () {
        if ((jQuery(this).height(), jQuery(this).offset().top + jQuery(this).height() > d + 300)) return jQuery(".scrolltop").removeClass("current"), jQuery(this).addClass("current"), !1;
              
    });
  }),
 
  jQuery(document.body).on("click","label.bsub-widget__plan-label", function() {
		var t = jQuery(this).find(".bsub-widget__text").text(); jQuery("#deliveryday").text(t); jQuery(".sub_dropdown .drop_box").hide();
	});
  
    jQuery('#activate-subscribe').on('click', function(){
   
      var t = $(this);
      t.parent().toggleClass('active');
      if( $('[data-bsub-selling-plan-group] input').is(':checked') == true ){
        $('.onceprogram input').prop('checked', true).trigger('change');
         $('button[name="add"]').text('Add to Cart');
        $('#activate-subscribe span').text('SUBSCRIBE & SAVE');
      }else{
        $('[data-bsub-selling-plan-group] input').prop('checked', true).trigger('change');
        $('button[name="add"]').text('SUBSCRIBE & SAVE');
        $('#activate-subscribe span').text('One-time Purchase');
      }
        var subplan = $('[data-bsub-selling-plan-input]:checked + div').text();
        $('.sub_offter .opts button span').text(subplan);
      
    });
    $('.sub_offter .opts li').on('click', function(){
      var t = $(this).text(), id = $(this).data('id');
        $('.sub_offter .opts button span').text(t);
         $('#plan_id,#planid').val( id );
       /* if( t == 'Week' ){
          $('input[value="2473558190"]').prop('checked', true).trigger('change');
        }  if( t == '2 Weeks ' ){
          $('input[value="2473590958"]').prop('checked', true).trigger('change');
        }  if( t == '4 Weeks' ){
          $('input[value="2473623726"]').prop('checked', true).trigger('change');
        }  if( t == '6 Weeks' ){
          $('input[value="2473656494"]').prop('checked', true).trigger('change');
        }*/
    });
    /*jQuery(document.body).on("change", 'input[name="bsub-selling-plan-group"]', function() {
		var t = jQuery(this),f = jQuery("#add-to_carts"),v = t.val();
      var varvalue = jQuery('input[name="lw_option"]:checked').data('value');
        
       var oprice = jQuery(".pdp-price strong").text();var original_price = oprice.replace("$", "");
		if (v != "once") {
          var subscribepice =  original_price*10/100;
          var total = original_price-subscribepice;
          jQuery("#subprice").text(total);
          // jQuery(".bsub-widget__plan:nth-child(3) label .bsub-widget__text").text("4 Weeks (recommended)");
          jQuery(".bsub-widget__plan:nth-child(3) label").trigger("click");
          f.find('input[type="number"]').data("prodprice", subscribepice);
			jQuery("#btn_txt").text("Subscribe");
        //  if( varvalue == '3l-box' ){ jQuery('#btn_txt').text('PRE-ORDER SUBSCRIPTION'); }
			jQuery("#lw_subtotal_price").html( total.toFixed(2));
		} else {
         jQuery("#btn_txt").text("Add to Cart");
        //    if( varvalue == '3l-box' ){ jQuery('#btn_txt').text('Pre-Order'); }
          jQuery("#lw_subtotal_price").text("$" + original_price);f.find(".quantity input").data("prodprice", original_price);
		} 
       
		f.find(".quantity input").val(1);
	});*/
 
 
    $('.sub_dropdown .drop_box').on('mouseleave', function(){
      $(this).slideUp();});
    setTimeout(function(){var rating = jQuery('span.spr-starrating.spr-summary-starrating').html();jQuery('#product_rating').html(rating);
  // jQuery('.swatch input[data-avaiability="true"]').prop('checked', true).trigger('change');
  var avaiability = jQuery('.swatch input:checked').data('avaiability');
           if( avaiability == false ){
              jQuery('.pdp_btns button[type="submit"]').hide();
              jQuery('.pdp_btns button[type="submit"]').next().html('<button id="soldout" class="add-to-cart addtocart" type="button" disabled>Sold Out</button>');
            }else{
              jQuery('#soldout').remove();
              jQuery('.pdp_btns button[type="submit"]').show();
            }       
    }, 1000 );
    setTimeout(function(){var number_star = jQuery('span.spr-starrating.spr-summary-starrating').attr('aria-label');jQuery('#product_rating').append(number_star);}, 7000 );
});